export interface DBaseStateAndValue {
	state: string;
	value: number | null;
}
